module.exports = __webpack_public_path__ + "static/media/porcelain-building-interior.72db37fc.jpg";